<template lang="html">
<!-- Sidebar -->
<div class="border-right" id="sidebar-wrapper">
    <div class="header-sidebar" slot="header">
        <img :src="basepath+'/unodc_logo.png'" alt="" width="200" />
    </div>
    <div class="list-group list-group-flush mb-3">
      
        <router-link to="/dashboard/Admin/adminDashboard" class="list-group-item list-group-item-action">
            <i class="material-icons">home</i> Dashboard
        </router-link>

        <div>
          <div slot="header" class="list-group-item list-group-item-action" id="mybutton"><i class="material-icons pr-1">brightness_low</i><b>Training Management</b>
          </div>
            <ul>
                <router-link to="/dashboard/admin/trainingWizard" class="list-group-item list-group-item-action" style="color:#8e8e8e">
                    <i class="material-icons">remove</i> Training Wizard
                </router-link>
                <router-link to="/dashboard/admin/essentialSystem" class="list-group-item list-group-item-action" style="color:#8e8e8e">
                    <i class="material-icons">remove</i> Essential Data
                </router-link>
                <router-link to="/dashboard/Admin/QuestionBankAdmin" class="list-group-item list-group-item-action" style="color:#8e8e8e">
                  <i class="material-icons">remove</i> Create Question Bank
                </router-link>
                  <router-link to="/dashboard/Admin/KnowledgeBaseArchives" class="list-group-item list-group-item-action" style="color:#8e8e8e">
                    <i class="material-icons">remove</i> Knowledge Base
                </router-link> 
                 <router-link to="/dashboard/Admin/questionbankarchives" class="list-group-item list-group-item-action" style="color:#8e8e8e">
                    <i class="material-icons">remove</i> Question Bank
                </router-link>
                <!-- <router-link to="/dashboard/Admin/fundingAgency" class="list-group-item list-group-item-action" style="color:#8e8e8e">
                    <i class="material-icons">remove</i> Funding Agnency
                </router-link> -->

                <!-- <router-link to="/dashboard/Admin/department" class="list-group-item list-group-item-action" style="color:#8e8e8e">
                    <i class="material-icons">remove</i> Department
                </router-link> -->

                <router-link to="/dashboard/Admin/subProgram" class="list-group-item list-group-item-action" style="color:#8e8e8e">
                    <i class="material-icons">remove</i> Subprogram
                </router-link>

                <router-link to="/dashboard/Admin/project" class="list-group-item list-group-item-action" style="color:#8e8e8e">
                    <i class="material-icons">remove</i> Project
                </router-link>

                <router-link to="/dashboard/Admin/training" class="list-group-item list-group-item-action" style="color:#8e8e8e">
                    <i class="material-icons">remove</i> Training
                </router-link>

                <!-- <router-link to="/dashboard/Admin/trainingType" class="list-group-item list-group-item-action" style="color:#8e8e8e">
                    <i class="material-icons">remove</i> Training Type
                </router-link>

                <router-link to="/dashboard/Admin/addThematicArea" class="list-group-item list-group-item-action" style="color:#8e8e8e">
                    <i class="material-icons">remove</i>Thematic Area
                </router-link> -->
                
            </ul>
        </div>

        <div>
            <div slot="header" class="list-group-item list-group-item-action" id="mybutton">
              <i class="material-icons pr-1">person</i><b>User Management</b>
            </div>

            <ul>
                <router-link to="/dashboard/Admin/employeeReg" class="list-group-item list-group-item-action" style="color:#8e8e8e">
                    <i class="material-icons">remove</i> Employees
                </router-link>
                <router-link to="/dashboard/Admin/addTrainer" class="list-group-item list-group-item-action" style="color:#8e8e8e">
                    <i class="material-icons">remove</i> Trainers
                </router-link>

            </ul>
        </div>

        <div>
            <div slot="header" class="list-group-item list-group-item-action" id="mybutton"><i class="material-icons pr-1">settings</i><b>Settings</b>
            </div>
            <ul>
                <!-- <router-link to="/dashboard/Admin/country" class="list-group-item list-group-item-action">
                    <i class="material-icons">remove</i> Country
                </router-link>
                <router-link to="/dashboard/Admin/province" class="list-group-item list-group-item-action">
                    <i class="material-icons">remove</i> Province
                </router-link> -->
                 <!-- <router-link to="/dashboard/Admin/city" class="list-group-item list-group-item-action">
                    <i class="material-icons">remove</i> City
                </router-link> -->
                 <!-- <router-link to="/dashboard/Admin/userDepartment" class="list-group-item list-group-item-action">
                    <i class="material-icons">remove</i> User(s) Department
                </router-link> -->
                 <!-- <router-link to="/dashboard/Admin/academicInfo" class="list-group-item list-group-item-action">
                    <i class="material-icons">remove</i> Academic Information
                </router-link> -->
                 <!-- <router-link to="/dashboard/admin/designation" class="list-group-item list-group-item-action">
                    <i class="material-icons">remove</i> Designation
                </router-link> -->
                 <!-- <router-link to="/dashboard/Admin/province" class="list-group-item list-group-item-action">
                    <i class="material-icons">remove</i> Province
                </router-link> -->
                <router-link to="/dashboard/Admin/role" class="list-group-item list-group-item-action">
                    <i class="material-icons">remove</i> Role
                </router-link>
                 <!-- <router-link to="/dashboard/Admin/relation-designation" class="list-group-item list-group-item-action">
                    <i class="material-icons">remove</i> Relation/Designation
                </router-link> -->
            </ul> 
        </div>

         <div style="margin-bottom:130px">
            <div slot="header" class="list-group-item list-group-item-action" id="mybutton"><i class="material-icons pr-1">chrome_reader_mode</i><b>Reports</b>
            </div>
               <router-link to="/dashboard/Admin/reportsAdminAll" class="list-group-item list-group-item-action"><i class="material-icons pr-1">remove</i
            >Brief Report
                </router-link>
                <router-link to="/dashboard/Admin/strategicReport" class="list-group-item list-group-item-action"><i class="material-icons pr-1">remove</i
            >Startegic Report
                </router-link>
                 <router-link to="/dashboard/Admin/map" class="list-group-item list-group-item-action"><i class="material-icons pr-1">remove</i
            >Map
                </router-link>
                
            <!-- <ul>
                 <router-link to="/dashboard/advisor/ReportsAdvisorGraphs" class="list-group-item list-group-item-action">
                  <i class="material-icons">remove</i>  Statistics & Graphs
                   
                  </router-link>
                  <router-link to="/dashboard/advisor/ReportsFilterAdvisor" class="list-group-item list-group-item-action">
                   <i class="material-icons">remove</i> Trainings
                    
                  </router-link>
                  <router-link to="/dashboard/Advisor/thematicAreaAdvisor" class="list-group-item list-group-item-action">
                    <i class="material-icons">remove</i> Thematic Area
                    
                  </router-link>
                    <router-link to="/dashboard/Advisor/subprogramListAdvisor" class="list-group-item list-group-item-action">
                    <i class="material-icons">remove</i> Sub Program Wise
                    
                  </router-link>
                    <router-link to="/dashboard/Advisor/projectListAdvisor" class="list-group-item list-group-item-action">
                  <i class="material-icons">remove</i> Project Wise
                    
                  </router-link>
            </ul> -->
        </div>

        <!-- Reports list Ends -->
        <!-- <vs-collapse>
            <vs-collapse-item icon-arrow="arrow_drop_down">
                <div slot="header" class="list-group-item list-group-item-action"> <i class="material-icons">report</i> Reports
                </div>
                <ul>
                    <router-link to="/dashboard/Admin/ReportAdminGraphs" class="list-group-item list-group-item-action">
                        Statistics & Graphs
                    </router-link>
                    <router-link to="/dashboard/Admin/ReportsFilter" class="list-group-item list-group-item-action">
                        Trainings
                    </router-link>
                    <router-link to="/dashboard/Admin/thematicArea" class="list-group-item list-group-item-action">
                        Thematic Area
                    </router-link>
                    <router-link to="/dashboard/Admin/subprogramList" class="list-group-item list-group-item-action">
                        Sub Program Wise
                    </router-link>
                    <router-link to="/dashboard/Admin/projectList" class="list-group-item list-group-item-action">
                        Project Wise
                    </router-link>

                </ul>
            </vs-collapse-item>
        </vs-collapse> -->
    </div>
</div>
</template>

<script>
//import { bus } from "../../../main";
export default {
  data: () => ({
    active: true,
    basepath: localStorage.getItem("BASE_PATH")
  }),
  created() {
    // bus.$on("sidebarStatus", data => {
    //   this.active = data;
    // });
  },
  methods: {
    // isSidebar() {
    //   bus.$emit("sidebarStatus", this.active);
    // }
  }
};
</script>

<style>
/* .list-group-item:hover {
  padding-left: 30px;
  transition: 0.5s ease;
} */

.vs-collapse {
  padding: 0px !important;
}

.vs-collapse-item--header {
  padding: 0px !important;
}
</style>
<style scoped>
/*!
 * Start Bootstrap - Simple Sidebar (https://startbootstrap.com/template-overviews/simple-sidebar)
 * Copyright 2013-2019 Start Bootstrap
 * Licensed under MIT (https://github.com/BlackrockDigital/startbootstrap-simple-sidebar/blob/master/LICENSE)
 */

body {
  overflow-x: hidden;
}

.material-icons {
  font-size: 20px !important;
  vertical-align: bottom;
}

#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}

/* scrollbar css starts */
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(7, 167, 225);
  border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(7, 167, 225);
}

/* scrollbar css ends */
@media print {
  #sidebar-wrapper {
    display: none;
  }
}
</style>
